import React, { useContext } from "react";

import { ThemeContext } from "../../contexts/ThemeContext";
import Experience from "../Experience/Experience";

import "./Education.css";
import EducationCard from "./EducationCard";
import { educationData } from "../../data/educationData";

function Education() {
  const { theme } = useContext(ThemeContext);
  return (
    <div
      className="education"
      id="resume"
      style={{ backgroundColor: theme.secondary }}
    >
      <div className="education-body">
        <div className="education-description">
          <h1 style={{ color: theme.primary }}>
            Doświadczenie i ukończone kursy
          </h1>
          <p style={{ color: theme.tertiary80 }}>
            {educationData.description1}
            <br />
            <br />
            {educationData.description2}
            <br />
            <br />
            {educationData.description3}
          </p>
        </div>
        <div className="education-image">
          <img src={educationData.image1} alt="education" />
        </div>
      </div>
      <div className="education-body">
        <div className="education-image">
          <img src={educationData.imageCooperation} alt="education" />
        </div>
        <div className="education-description">
          <h2 style={{ color: theme.primary }}>Z kim pracuje</h2>
          <ul>
            {educationData.cooperations.map((li, i) => (
              <li key={i}>
                <p style={{ color: theme.tertiary80 }}>{li}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <Experience />

      <div className="education-body">
        <div className="education-description">
          <h1 style={{ color: theme.primary }}>Kursy fizjoterapeutyczne</h1>
          {educationData.cards.map((edu) => (
            <EducationCard
              key={edu.id}
              id={edu.id}
              institution={edu.institution}
              course={edu.course}
              startYear={edu.startYear}
              endYear={edu.endYear}
            />
          ))}
        </div>
        <div className="education-image">
          <img src={theme.eduimg} alt="education" />
        </div>
      </div>
    </div>
  );
}

export default Education;
